import React, { useContext, useState, useEffect } from "react";
import { Image, Row, Col, notification } from "antd";
import logo from "../../assets/images/my-friend-logo-blue.svg";
import navIcon from "../../assets/images/Drawer_Image.svg";
import { useNavigate } from 'react-router-dom';
import { componentStyles } from "./UserHeaderStyles";
import { getImageUrlOfUserProfile } from '../../api/User.js';
import { SessionContext } from "../chatbot.conversation/SessionContext";

const UserHeader = ({ setDrawer, backgroundColor, headerLogo }) => {
  const navigate = useNavigate();
  const { sessionActive } = useContext(SessionContext)
  const [imageUrl, setImageUrl] = useState('');
  const handleClick = () => { navigate('/landing-page')}
  const headerStyle = backgroundColor
    ? { ...componentStyles.padding, ...componentStyles.headerStyle, backgroundColor }
    : { ...componentStyles.padding, ...componentStyles.headerStyle };

  const fetchImageUrl = async () => {
    try {
      const response = await getImageUrlOfUserProfile();
      if (response && response.profileImageUrl) {
        setImageUrl(response.profileImageUrl);
      }
    } catch (error) {
      console.error("Error fetching profile image URL:", error);
      notification.error({
        message: 'Fetch Failed',
        description: 'There was an error fetching your profile image. Please try again.',
        placement: 'topRight',
      });
    }
  };

  useEffect(() => {
    fetchImageUrl();
  }, []);

  return (
    <Row justify="space-between" align="middle" style={headerStyle}>
      <Col xs={14} md={12}>
        <Image
          src={headerLogo ? headerLogo : logo}
          alt="my-friend-logo"
          preview={false}
          style={componentStyles.logo}
          onClick={handleClick}
        />
      </Col>
      <Col>
        {!sessionActive &&
          <Image
            onClick={setDrawer}
            src={imageUrl || navIcon}
            preview={false}
            alt="nav-icon"
            style={componentStyles.drawerIcon}
          />}
      </Col>
    </Row>
  );
};

export default UserHeader;
